/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import DisplayedWordVo from './DisplayedWordVo';
import IseTextVo from './IseTextVo';
import RefWordVo from './RefWordVo';




  /**
   * The DialogueItemVo model module.
   * @module drill/model/DialogueItemVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DialogueItemVo</code>.
   * @alias module:drill/model/DialogueItemVo
   * @class
   * @param sortKey {Integer} 顺序，从1开始
   * @param actor {String} 演员（PIL、PIL1、PIL2、CTL、GND）
   * @param markedText {String} 【】标注的读法文本
   * @param displayText {Array.<module:drill/model/DisplayedWordVo>} 显示颜色用文本
   * @param refText {Array.<module:drill/model/RefWordVo>} 打分用文本
   * @param newline {Boolean} 本句话新起一行
   * @param startTime {Integer} 开始时间ms
   * @param answerTime {Integer} 可用答题时长ms
   */
  var exports = function(sortKey, actor, markedText, displayText, refText, newline, startTime, answerTime) {
    var _this = this;


    _this['sortKey'] = sortKey;

    _this['actor'] = actor;
    _this['markedText'] = markedText;

    _this['displayText'] = displayText;
    _this['refText'] = refText;




    _this['newline'] = newline;
    _this['startTime'] = startTime;
    _this['answerTime'] = answerTime;

  };

  /**
   * Constructs a <code>DialogueItemVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DialogueItemVo} obj Optional instance to populate.
   * @return {module:drill/model/DialogueItemVo} The populated <code>DialogueItemVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dialogueDrillId')) {
        obj['dialogueDrillId'] = ApiClient.convertToType(data['dialogueDrillId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'actor')) {
        obj['actor'] = ApiClient.convertToType(data['actor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'markedText')) {
        obj['markedText'] = ApiClient.convertToType(data['markedText'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subjectWords')) {
        obj['subjectWords'] = ApiClient.convertToType(data['subjectWords'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'displayText')) {
        obj['displayText'] = ApiClient.convertToType(data['displayText'], [DisplayedWordVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'refText')) {
        obj['refText'] = ApiClient.convertToType(data['refText'], [RefWordVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'iseText')) {
        obj['iseText'] = IseTextVo.constructFromObject(data['iseText']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'tips')) {
        obj['tips'] = ApiClient.convertToType(data['tips'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'translatedText')) {
        obj['translatedText'] = ApiClient.convertToType(data['translatedText'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'note')) {
        obj['note'] = ApiClient.convertToType(data['note'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'newline')) {
        obj['newline'] = ApiClient.convertToType(data['newline'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'startTime')) {
        obj['startTime'] = ApiClient.convertToType(data['startTime'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'answerTime')) {
        obj['answerTime'] = ApiClient.convertToType(data['answerTime'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUri')) {
        obj['imageUri'] = ApiClient.convertToType(data['imageUri'], 'String');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 顺序，从1开始
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 对话id
   * @member {Integer} dialogueDrillId
   */
  exports.prototype['dialogueDrillId'] = undefined;
  /**
   * 演员（PIL、PIL1、PIL2、CTL、GND）
   * @member {String} actor
   */
  exports.prototype['actor'] = undefined;
  /**
   * 【】标注的读法文本
   * @member {String} markedText
   */
  exports.prototype['markedText'] = undefined;
  /**
   * soe主题词组
   * @member {String} subjectWords
   */
  exports.prototype['subjectWords'] = undefined;
  /**
   * 显示颜色用文本
   * @member {Array.<module:drill/model/DisplayedWordVo>} displayText
   */
  exports.prototype['displayText'] = undefined;
  /**
   * 打分用文本
   * @member {Array.<module:drill/model/RefWordVo>} refText
   */
  exports.prototype['refText'] = undefined;
  /**
   * 用于讯飞打分的文本
   * @member {module:drill/model/IseTextVo} iseText
   */
  exports.prototype['iseText'] = undefined;
  /**
   * 提示
   * @member {String} tips
   */
  exports.prototype['tips'] = undefined;
  /**
   * 翻译
   * @member {String} translatedText
   */
  exports.prototype['translatedText'] = undefined;
  /**
   * 解析
   * @member {String} note
   */
  exports.prototype['note'] = undefined;
  /**
   * 本句话新起一行
   * @member {Boolean} newline
   */
  exports.prototype['newline'] = undefined;
  /**
   * 开始时间ms
   * @member {Integer} startTime
   */
  exports.prototype['startTime'] = undefined;
  /**
   * 可用答题时长ms
   * @member {Integer} answerTime
   */
  exports.prototype['answerTime'] = undefined;
  /**
   * 图片uri
   * @member {String} imageUri
   */
  exports.prototype['imageUri'] = undefined;



  export default exports;
;


